<template lang="pug">
  UiSelectFilter(
    :smart="true"
    :placeholder="placeholder"
    :title="title"
    :value="value"
    :option="options"
    :popup="popup"
    :can-unset="canUnset"
    :max-height="maxHeight"
    :append-body="true"
    :class="inputClass"
    :loading="loadingData"
    :show-title="showTitle"
    :z-index="1000"
    @input="onInput"
    @smartInput="onSmartInput"
  )
</template>

<script>
import UiSelectFilter from '../SelectFilter';
import { debounce } from 'lodash';
import axios from 'axios';

export default {
  name: 'UiCityInput',
  components: { UiSelectFilter },
  props: {
    placeholder: {
      type: String,
      default: 'Выберите местоположение'
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [Object, String],
      required: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    canUnset: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 150
    },
    inputClass: {
      type: String,
      default: ''
    },
    popup: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    cityList: [],
    loadingData: false,
    dadataAPI:
      'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
    DADATA_TOKEN: '9d9eb4a95be2894957a6c0b29d4bc11d39d8970a'
  }),
  computed: {
    options() {
      return this.cityList.length
        ? this.cityList
        : this.value
        ? [{ title: this.value, value: this.value }]
        : [];
    }
  },
  created() {
    this.fetchSuggestionsDebounced = debounce(e => {
      this.fetchSuggestions(e);
    }, 500);
  },
  beforeDestroy() {
    this.fetchSuggestionsDebounced.cancel();
  },
  methods: {
    onInput(event) {
      this.$emit('input', event);
    },
    onSmartInput(event) {
      this.fetchSuggestionsDebounced(event);
    },
    fetchSuggestions(input) {
      this.loadingData = true;
      axios({
        method: 'post',
        headers: {
          Authorization: 'Token ' + this.DADATA_TOKEN
        },
        url: this.dadataAPI,
        data: {
          query: input,
          count: 20,
          locations: [
            {
              country: '*'
            }
          ],
          from_bound: { value: 'city' },
          to_bound: { value: 'settlement' }
        }
      })
        .then(({ data }) => {
          this.cityList = data.suggestions.map(s => ({
            title: s.value,
            value: s.value
          }));
          this.loadingData = false;
        })
        .catch(e => {
          console.error(e);
          this.loadingData = false;
        });
    }
  }
};
</script>
